/* eslint-disable max-len */
import 'react';

const SharePowerSvg = (
    props: React.SVGProps<SVGSVGElement>
): React.PropsWithoutRef<React.ReactSVGElement> => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="mask0_32093_23525" style={{'maskType': 'alpha'}} maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18">
            <rect width="18" height="18" fill="black" />
        </mask>
        <g mask="url(#mask0_32093_23525)">
            <circle cx="9" cy="5.625" r="3.375" stroke="#39404D" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M9.375 10.875H5.625C3.96815 10.875 2.625 12.2181 2.625 13.875V14.625C2.625 15.2463 3.12868 15.75 3.75 15.75H9.375" stroke="#39404D" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round" />
            <path fillRule="evenodd" clipRule="evenodd" d="M11.5039 11.0356C11.6721 10.7473 11.9807 10.5701 12.3145 10.5701H14.7548C15.0886 10.5701 15.3972 10.7473 15.5654 11.0356L16.7818 13.1209C16.9523 13.4131 16.9523 13.7744 16.7818 14.0666L15.5654 16.1519C15.3972 16.4402 15.0886 16.6175 14.7548 16.6175H12.3145C11.9807 16.6175 11.6721 16.4402 11.5039 16.1519L10.2875 14.0666C10.1171 13.7744 10.1171 13.4131 10.2875 13.1209L11.5039 11.0356ZM12.3744 11.6127L11.2188 13.5938L12.3744 15.5748H14.695L15.8506 13.5938L14.695 11.6127H12.3744Z" fill="#39404D" />
            <path d="M14.2847 13.5938C14.2847 14.008 13.9489 14.3438 13.5347 14.3438C13.1205 14.3438 12.7847 14.008 12.7847 13.5938C12.7847 13.1795 13.1205 12.8438 13.5347 12.8438C13.9489 12.8438 14.2847 13.1795 14.2847 13.5938Z" fill="#39404D" />
        </g>
    </svg>

);
export default SharePowerSvg;
